<script setup lang="ts">
defineOptions({
	name: 'IconShield',
})

interface Props {
	class?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50 w-8 h-8',
})
</script>

<template>
	<svg
		:class="props.class"
		viewBox="0 0 57 57"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M23.7556 24.7692H33.0282C34.3032 24.7692 35.3463 25.8123 35.3463 27.0873V34.1646C35.3463 35.4442 34.3078 36.4827 33.0282 36.4827H23.7556C22.476 36.4827 21.4375 35.4442 21.4375 34.1646V27.0873C21.4375 25.8077 22.476 24.7692 23.7556 24.7692Z"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M24.4805 24.7684V21.8406C24.4805 19.6848 26.2283 17.9369 28.3842 17.9369C30.5401 17.9369 32.288 19.6848 32.288 21.8406V24.7638"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M14.4213 12.2975L26.8048 7.78638C27.8295 7.41316 28.9537 7.41316 29.9784 7.78638L42.3619 12.2975C45.1112 13.2989 46.9379 15.9091 46.9379 18.8323V30.1263C46.9379 38.4275 42.7003 41.8329 30.6993 48.6273C29.269 49.4364 27.5165 49.4364 26.0862 48.6273C14.0852 41.8329 9.84766 38.4275 9.84766 30.1263V18.8323C9.84766 15.9091 11.6743 13.2989 14.4213 12.2975Z"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
